<template>
  <button
    v-bind="$attrs"
    type="button"
    class="border-gray-30 hover:border-gray-40 text-brand-80 box-border rounded border bg-white px-3 py-0.5 text-xs font-normal"
  >
    <slot />
  </button>
</template>
